import strings from './strings.json';

// STRINGS
// eslint-disable-next-line
export const t = (key, data = {}) => {
  if (!Object.keys(strings).includes(key)) {
    return null;
  }
  if (!Object.keys(data).length) {
    return strings[key];
  }
  const dataRE = new RegExp(`{${Object.keys(data).join('}|{')}}`, 'gi');
  return strings[key].replace(dataRE, matched => data[matched.substr(1, matched.length - 2)]);
};



// WEBPACK FOOTER //
// ./src/helpers.js